// SYSTEM > 관리자 현황
//
import {adminDataTreeConvert, getParentTreeItem, fnGetCodeVal} from '~/utils/admin-common'
import {code} from '~/static/code.json'
import {pcDownloadFile} from '~/utils/files'

const getDefaultState = () => {
  return {
    codes: code,
    // api url 목록
    apiUrl: {
      groupTreeUrl: '/api/sm/group-tree',
      adminStatus: '/api/sm/admin/admin-status'
    },
    downloadURL: '/api/sm/admin/download',
    // 임시데이터
    tmpData: [],
    // group-tree data
    orgAdminGroupData: [],
    // convert tree data : group-tree
    adminGroupTreeData: [],
    // 관리자 리스트
    maxRecord: 0,
    selectedTree: null,
    orgAdminData: [],
    adminListData: [],
    expanded: [],
    adminGruopSelected: null,
    errorMessage: '',
    treeInfo: {text: '', id: 0},
    previousTreeInfo: {text: '', id: 0}
  }
}
export const state = getDefaultState()
export const mutations = {
  releaseAllState (state) {
    // Object.assign(state, getDefaultState())
    const defaultState = getDefaultState()
    _.forEach(defaultState, (v, k) => {
      state[k] = v
    })
  },
  getAdminGroupList (state, data) {
    state.orgAdminGroupData = data.org
    const min = data.org.reduce((p, c) => {
      return p.admin_id > c.admin_id ? c : p
    })
    state.adminGroupTreeData = adminDataTreeConvert(data.org, min.admin_id)
    state.expanded = data.org.map((item) => {
      return item.admin_id
    })
  },
  getAdminGroupKeywordSearch (state, data) {
    state.adminGroupTreeData = data
  },
  getAdminDataList (state, data) {
    const tmp = data.datalist
    const dataFilter = tmp.filter(item => {
      item.admin_stat_name = fnGetCodeVal('adminStats', item.admin_stat)
      item.admin_locale_type_name = fnGetCodeVal('admin_locale_type', item.admin_locale_type + '')
      return item
    })
    state.adminListData = dataFilter
    state.orgAdminData = dataFilter
    state.maxRecord = data.maxRecord
    state.selectedTree = data.selectedTree
  },
  acsAdminDataList (state, payload) {
    state.adminListData = payload.result
  },
  mutErrorMessage (state, payload) {
    state.errorMessage = payload
  },
  seletedTreeInfo (state, data) {
    state.previousTreeInfo = _.cloneDeep(state.treeInfo)
    state.treeInfo = data
  }
}
export const actions = {
  // admin group tree 가져오기
  async getAdminGroupList ({commit, state}, { adminId = 1, externalAuth = false } = {}) {
    const result = {org: [], tree: []}
    const res = await this.$axios.$get(state.apiUrl.groupTreeUrl, {
      params: {
        admin_id: adminId,
        extern_yn: externalAuth ? 1 : 0
      },
      loading: false,
      successAlert: false
    })
    if (res.code === 'ok') {
      result.org = res.result
      commit('getAdminGroupList', result)
    } else {
      const success = {}
      success.title = 'getAdminGroupList'
      success.error = result.msg
      commit('mutErrorMessage', success)
    }
    return res
  },
  // tree 키워드 검색
  getAdminGroupKeywordSearch ({commit, state}, terms) {
    let tmpParent = []
    let result = []
    const orgData = state.orgAdminGroupData
    const list = orgData.filter((item) => {
      return item.admin_name.indexOf(terms) >= 0
    })

    if (list.length > 0) {
      // this.adminGroupTreeData = this.treeConvert(list, list[0].admin_id)
      // Tree 상위 아이템 가져오기
      list.forEach((item) => {
        tmpParent = getParentTreeItem(orgData, tmpParent, item.parent_admin_id)
      })
      const searchData = list.concat(tmpParent)
      // 중복제거
      const uniq = searchData.reduce((a, b) => {
        if (a.indexOf(b) < 0) a.push(b)
        return a
      }, [])
      const min = uniq.reduce((p, c) => {
        return p.admin_id > c.admin_id ? c : p
      })
      result = adminDataTreeConvert(uniq, min.admin_id)
      commit('getAdminGroupKeywordSearch', result)
    } else {
      this.adminGroupTreeData = []
    }
  },
  // admin list
  async getAdminDataList ({commit, state}, adminId) {
    const result = {datalist: null, maxRecord: 0, selectedTree: null}
    try {
      const data = await this.$axios.$get(`${state.apiUrl.adminStatus}?admin_id=${adminId}`)
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      result.datalist = data.result
      result.maxRecord = data.result.length
      result.selectedTree = adminId
      commit('getAdminDataList', result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // data table 키워드 검색
  acsAdminDataList ({commit, state}, keyword) {
    const result = {}
    result.keyword = keyword
    if (keyword === '') {
      result.result = state.orgAdminData.filter((item) => {
        item.admin_login_uname = item.admin_login_uname !== null ? item.admin_login_uname : ''
        return item
      })
    } else {
      const rKeyword = RegExp(keyword)
      result.result = state.orgAdminData.filter((item) => {
        item.admin_login_uname = item.admin_login_uname !== null ? item.admin_login_uname : ''
        return Object.keys(item).filter(vkey => { return rKeyword.test(item[vkey]) }).length > 0
      })
    }
    commit('acsAdminDataList', result)
  },
  acsSetErrorMessage ({commit, state}, payload) {
    const result = {}
    result.error = payload
    commit('mutErrorMessage', result)
  },
  async getDownload ({commit, state}) { // PC로 파일 다운로드
    const param = {
      responseType: 'blob',
      method: 'get',
      successAlert: false
    }
    try {
      const {data, fileName} = await this.$axios.$file(state.downloadURL, param)
      const nameData = fileName.replace('UTF-8\'\'', '')
      pcDownloadFile(data, nameData)
      return {code: 'ok'}
    } catch (error) {
      commit('mutErrorMessage', {error: error})
    }
  }
}
export const getters = {}
export const strict = false
